/**
 * Created by sagardesai on 22/06/18.
 */

import * as types from "../actions/types/index";
import {setInitialState} from "../util/utility";

const INITIAL_STATE = setInitialState({
    followingList: null,
    follow_unfollow_data: null
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.FOLLOWING_LIST_REQUEST:
        case types.FOLLOW_UNFOLLOW_BROADCASTER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.FOLLOWING_LIST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                followingList: action.payload
            };
        case types.FOLLOWING_LIST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                followingList: action.payload.error,
            };
        case types.RESET_FOLLOWING_LIST:
            return {
                ...state,
                followingList: action.payload,
            };
        case types.FOLLOW_UNFOLLOW_BROADCASTER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                follow_unfollow_data: action.payload
            };
        case types.FOLLOW_UNFOLLOW_BROADCASTER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                follow_unfollow_data: action.payload.error,
            };
        case types.RESET_FOLLOW_UNFOLLOW_BROADCASTER:
            return {
                ...state,
                isFetching: false,
                follow_unfollow_data: action.payload,
            };
        case types.SET_SEARCH_FOLLOWING_STATE:
            return {
                ...state,
                performSearch: action.payload,
            };

        default:
            return {
                ...state
            }
    }
}